import React from 'react'
import styled from 'styled-components'
import Page from 'components/Layout/Page'
import TotalValueLockedCard from 'views/Home/components/TotalValueLockedCard'
import DmdStats from 'views/Home/components/DmdStats'
import Farms from 'views/Home/components/Farms'
import Pools from 'views/Home/components/Pools'

const PageContent = styled.div`
  margin: 24px 30px;
`

const CTACards = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  grid-gap: 24px;
  flex-wrap: wrap;

  ${({ theme }) => theme.mediaQueries.xl} {
    flex-wrap: nowrap;
    margin-bottom: 32px;
    grid-gap: 32px;

    & > div {
      grid-column: span 8;
    }
  }
`

const Stats: React.FC = () => {
  return (
    <Page>
      <PageContent>
        <CTACards>
          <TotalValueLockedCard />
          <DmdStats />
        </CTACards>
        <Farms />
        <Pools />
      </PageContent>
    </Page>
  )
}

export default Stats
